export const business = {
  name: 'Haircuts Factory',
  address: '316 Main Street, Dundee, FL 33838',
  addressShort: '316 Main Street',
  city: 'Dundee, FL 33838',
  phoneDisplay: '+1 787-429-0831',
  phoneHref: 'tel:+17874290831',
  whatsappHref:
    'https://wa.me/17874290831?text=Hola%2C%20quiero%20agendar%20una%20cita%20en%20Haircuts%20Factory',
  mapsEmbed:
    'https://maps.google.com/maps?q=316%20Main%20Street%2C%20Dundee%2C%20FL%2033838&z=16&output=embed',
  mapsDirections:
    'https://www.google.com/maps/dir/?api=1&destination=316+Main+Street+Dundee+FL+33838',
  logo: 'https://cdn.magicpatterns.com/uploads/c6Vji2bo6kUC1GFHdzVPDn/logo_factory_nuevo.png',
}

export const images = {
  banner: 'https://cdn.magicpatterns.com/uploads/9VaFgetyixAS54Wm1oU12z/nueva_foto_factory.jpg',
  ownerAtWork: 'https://cdn.magicpatterns.com/uploads/esmSib2nLVis7FYKyP6mVN/foto_de_banner.png',
  shopInterior:
    'https://cdn.magicpatterns.com/uploads/hEc9fufFqMsdjgrinyJeTa/foto_barberia_factory.jpg',
  clippersWork: 'https://cdn.magicpatterns.com/uploads/vC8SLWW2r5a5pafUN1cBda/foto_modelo_2_nuevo.png',
  curlyFade: 'https://cdn.magicpatterns.com/uploads/jG4CX3TzpoAqapQxDrdSmy/foto_modelo_5_nuevo.png',
  taperBack: 'https://cdn.magicpatterns.com/uploads/e57TwgoEYf1MDF4b1NvzVY/foto_modelo_4_nuevo.png',
  beardFade: 'https://cdn.magicpatterns.com/uploads/7w48ZRjem4vkMAp9wrNnXk/foto_modelo_nuevo1.png',
}

export const barberOrder = ['alex', 'gardy', 'michael', 'cuba', 'yady', 'malvin'] as const

export type BarberId = (typeof barberOrder)[number]

export const barbers: Record<BarberId, { name: string; image: string }> = {
  gardy: {
    name: 'Gardy',
    image: 'https://cdn.magicpatterns.com/uploads/xsJZFvQ1nJjVFZiJ53z5rJ/fotos_barbero_factory.png',
  },
  michael: {
    name: 'Michael',
    image: 'https://cdn.magicpatterns.com/uploads/cygXqBr81HUeh9yU357JtS/foto_barbero_facrory.png',
  },
  cuba: {
    name: 'Cuba',
    image:
      'https://cdn.magicpatterns.com/uploads/m64YvM6PCHdZvDD18C3txv/74FAA21B-8FD8-4EB0-AD89-5FFD2BB2BB8F.png',
  },
  alex: {
    name: 'Alex',
    image: 'https://cdn.magicpatterns.com/uploads/4ipc5ffWXtz52HZ4aiM2hh/foto_factory_barbero.png',
  },
  yady: {
    name: 'Yady',
    image:
      'https://cdn.magicpatterns.com/uploads/qYt57cZXngMJS46PAVybjo/003040FF-3874-4309-B7CC-7DED6ABB6A2F.png',
  },
  malvin: {
    name: 'Malvin',
    image: 'https://cdn.magicpatterns.com/uploads/oE4NKcg6RwDkLKnNVi4x7y/fotobarbero_factory.jpg',
  },
}

/** Photo order for the gallery carousel. Captions and alt text live in data/content.ts. */
export const galleryPhotos = [
  images.ownerAtWork,
  images.beardFade,
  images.clippersWork,
  images.curlyFade,
  images.taperBack,
]

/** Price list. Names live in data/content.ts; `price: null` means the price varies. */
export const priceListImage =
  'https://cdn.magicpatterns.com/uploads/onHtEwnzifcZc3nbdji53Q/precios_haircutsfactory.jpg'

export const priceOrder = [
  'haircut',
  'haircutBeardTowel',
  'haircutBeardSteamer',
  'kids',
  'beardEyebrows',
  'eyebrows',
  'senior',
  'shampoo',
  'vip',
  'platinum',
] as const

export type PriceId = (typeof priceOrder)[number]

export const priceList: Record<PriceId, { price: string | null; minutes: number; featured?: boolean }> = {
  haircut: { price: '$35.00', minutes: 30 },
  haircutBeardTowel: { price: '$40.00', minutes: 45 },
  haircutBeardSteamer: { price: '$50.00', minutes: 60 },
  kids: { price: '$25.00', minutes: 30 },
  beardEyebrows: { price: '$30.00', minutes: 40 },
  eyebrows: { price: '$10.00', minutes: 15 },
  senior: { price: '$15.00', minutes: 30 },
  shampoo: { price: null, minutes: 15 },
  vip: { price: '$120.00', minutes: 70, featured: true },
  platinum: { price: '$140.00', minutes: 150, featured: true },
}

/** Opening times, index 0 = Monday. Day names live in data/content.ts. */
export const hours = [
  { time: '9:00 AM – 7:00 PM' },
  { time: '9:00 AM – 7:00 PM' },
  { time: '9:00 AM – 7:00 PM' },
  { time: '9:00 AM – 7:00 PM' },
  { time: '9:00 AM – 7:00 PM' },
  { time: '8:00 AM – 6:00 PM' },
  { time: '', closed: true },
]

export const timeSlots = [
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
]
